export const withparamsModelHTMLStringModel = (type, formattedOptions) => {
  return type === "model" && formattedOptions.length
    ? ` <span style="color: #606;">data-options</span><span style="color: #660;">=</span>` +
        `<span style="color:#080;">"${formattedOptions.trim()}"</span>`
    : "";
};
